<template>
  <v-data-table
    :headers="headers"
    :items="indicacoesCompetencia"
    :search="opcoes.pesquisa"
    :sort-by="opcoes.ordenarPor"
    :sort-desc="opcoes.decrescente"
    class="elevation-0"
  >
    <!-- ordenar por e pesquisar -->
    <template v-slot:top>
      <v-row class="mb-2">
        <v-toolbar flat>
          <v-toolbar-title>
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              {{ titulo }}
            </h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-row>

      <!-- ordenar por -->
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <app-sort v-model="opcoes" />
        </v-col>

        <v-col
          cols="0"
          md="4"
        />

        <!-- pesquisar -->
        <v-col
          cols="12"
          md="4"
        >
          <app-search v-model="opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- numeração -->
    <template v-slot:[`item.numero`]="{ index }">
      <span>{{ index + 1 }}</span>
    </template>

    <!-- nome da competência -->
    <template v-slot:[`item.nomeCompetencia`]="{ item }">
      <span :class="item.isGeral ? 'secondary--text' : 'grey-text'">{{
        item.nomeCompetencia
      }}</span>
    </template>

    <!-- total de quantidades -->
    <template v-slot:[`body.append`]>
      <tr>
        <td />
        <td align="center">
          <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
        </td>
        <td align="center">
          <strong>{{ totalIndicacoes }}</strong>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'TabelaIndicacaoCompetenciaTecnica',

  components: { AppSort, AppSearch },

  props: {
    indicacoesCompetencia: {
      type: Array,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'N°',
          value: 'numero',
          width: '10%',
          sortable: false,
        },
        {
          text: 'COMPETÊNCIA',
          value: 'nomeCompetencia',
          width: '80%',
          sortable: false,
        },
        {
          text: 'QUANTIDADE',
          value: 'nIndicacoes',
          width: '10%',
          sortable: false,
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nomeCompetencia',
        selecionado: { id: 'nomeCompetencia', descricao: 'Competência' },
        lista: [
          { id: 'nIndicacoes', descricao: 'Quantidade de Indicações' },
          { id: 'nomeCompetencia', descricao: 'Competência' },
        ],
      },
    };
  },

  computed: {
    totalIndicacoes() {
      return _.sumBy(this.indicacoesCompetencia, 'nIndicacoes');
    },
  },
};
</script>
